import { ExternalLink } from "lucide-react";
import { SettingsPageHeader } from "@/pages/settings/settings-placeholder";
import { externalLegalLinks, BUSINESS } from "@/data/legal";

export function LegalNoticesSettingsPage() {
  return (
    <div>
      <SettingsPageHeader
        title="Legal Notices"
        subtitle="Editlock's policies, terms, and how to reach us."
      />

      <div className="divide-y divide-border overflow-hidden rounded-xl border border-border">
        {externalLegalLinks.map((l) => (
          <a
            key={l.href}
            href={l.href}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-between px-4 py-3 text-sm transition-colors hover:bg-muted"
          >
            <span>{l.label}</span>
            <ExternalLink className="h-4 w-4 text-muted-foreground" />
          </a>
        ))}
      </div>

      <p className="mt-4 text-sm text-muted-foreground">
        Questions? Support:{" "}
        <a className="text-brand underline underline-offset-2" href={`mailto:${BUSINESS.supportEmail}`}>
          {BUSINESS.supportEmail}
        </a>{" "}
        · Legal &amp; billing:{" "}
        <a className="text-brand underline underline-offset-2" href={`mailto:${BUSINESS.legalEmail}`}>
          {BUSINESS.legalEmail}
        </a>
      </p>
    </div>
  );
}
